<template>
  <div class="app-teaser" :class="{ 'is-edit-mode': isMagnoliaEdit }">
    <EditableArea :content="main">
      <SliderElement :components="mapNodes(main)" :swiper-options="swiperOptions"></SliderElement>
    </EditableArea>
  </div>
</template>

<script setup>
import { EditableArea } from "@magnolia/vue-editor";
import { mapNodes } from "~/utils/helper/magnolia";
import { screens } from "~/tailwind.config.screens";
import "~/assets/css/thirdparty/swiper.css";
import SliderElement from "~/templates/elements/SliderElement.vue";

const { isMagnoliaEdit } = useMagnoliaContext();

const swiperOptions = {
  slidesPerView: 1.2,
  spaceBetween: 32,
  centeredSlides: true,
  loop: false,
  breakpoints: {
    [parseInt(screens.sm)]: {
      slidesPerView: 3.2,
      spaceBetween: 20,
    },
    [parseInt(screens.xl)]: {
      centeredSlides: false,
      slidesPerView: 4,
      spaceBetween: 24,
    },
  },
};
defineProps(["main"]);
</script>
<style>
.app-teaser {
  .swiper,
  .swiper-wrapper {
    @apply mx-auto overflow-visible;
  }
  /**
      Disable slider in edit mode and make area scrollable
  */
  &.is-edit-mode .swiper-wrapper {
    @apply overflow-auto;

    transform: none !important;
  }
}
</style>
